module.exports = __webpack_public_path__ + "img/img_diagnosis.49827af0.jpg";